export const TRIAL_EXPIRED_EVENT = "trial-expired";

export const TRIAL_EXPIRED_ALLOWED_PATHS = ["/get-support", "/tenants", "/logout", "/login", "/my-account"];

export const isTrialExpiredAllowedPath = (pathname: string) => {
  return TRIAL_EXPIRED_ALLOWED_PATHS.includes(pathname);
};
